import type {GuidedMiddleware} from '../models/middleware';

const dropShortQuery: GuidedMiddleware = async (params, next) => {
    const { guidedRequest } = params;
    if ((guidedRequest?.searchTerm?.length ?? 0) < 3) {
      return [];
    }
    return next(params);
};

export default dropShortQuery;
